/**
 * Utility functions for company logo handling
 */

import React from 'react';

/**
 * Creates a factory function that returns error handlers for company logos with fallback to default logo
 * Uses a closure to track which logos have tried fallback
 */
export function createLogoErrorHandlerFactory() {
  // Track which logos have tried fallback using a Set in closure
  const logoFallbackTried = new Set<string>();

  return (companyId: string) => {
    const key = companyId;
    const defaultLogoSrc = '/company-logo-default.svg';

    return (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
      const target = e.target as HTMLImageElement;

      // If WebP failed and we haven't tried the fallback yet, use default logo
      if (!logoFallbackTried.has(key)) {
        logoFallbackTried.add(key);
        // Clear srcset first (DOM property is lowercase), then set src to default logo
        target.srcset = '';
        target.src = defaultLogoSrc;
      }
    };
  };
}
